module.exports = __webpack_public_path__ + "img/about_logo.564753ac.png";